import { render, staticRenderFns } from "./InputTableCustom.vue?vue&type=template&id=2535382a&scoped=true"
import script from "./InputTableCustom.vue?vue&type=script&lang=js"
export * from "./InputTableCustom.vue?vue&type=script&lang=js"
import style0 from "./InputTableCustom.vue?vue&type=style&index=0&id=2535382a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535382a",
  null
  
)

export default component.exports